export default __webpack_public_path__ + "locales/lv/UploadPanel.json?hash=90b999c968fd2b591b4f0370feae1271";